/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */
import { createSelector } from 'reselect';
import { isRMDDirectEnabled, rmdGaugeEnabled } from 'services/FeatureFlags';

const getRMDistributionSummary = (state) =>
  state.requiredMinimumDistributionSummary;
const getRMDDistribution = (state) => state.requiredMinimumDistribution;

export const getRequiredMinimumDistributionState = createSelector(
  getRMDistributionSummary,
  getRMDDistribution,
  (rmdSummary, rmdDistribution) => {
    return isRMDDirectEnabled() ? rmdSummary : rmdDistribution;
  }
);

export const getRMDData = createSelector(
  getRequiredMinimumDistributionState,
  (rmdData) => {
    if (isRMDDirectEnabled()) {
      if (rmdGaugeEnabled()) {
        return {
          ...rmdData,
          customerEligible: rmdData?.rmdSummary.eligibleForRMD,
          customerPreEligible: rmdData?.rmdSummary.preRMDEligible
        };
      }
      return {
        totalAmount: rmdData.rmdSummary?.totalRMD,
        distributionAmountYtd: rmdData?.rmdSummary?.distributedAmountRMD,
        remainingAmount: rmdData?.rmdSummary?.amountToBeDistributed,
        customerEligible: rmdData?.rmdSummary.eligibleForRMD,
        customerPreEligible: rmdData?.rmdSummary.preRMDEligible,
        displayYtdDistributions:
          rmdData?.rmdSummary?.displayDistributionColumns,
        effectiveYear: rmdData?.rmdSummary?.rmdYear
      };
    }
    return rmdData;
  }
);

export const getIsRMDEligible = createSelector(getRMDData, (rmdData) => {
  return rmdGaugeEnabled()
    ? rmdData?.rmdSummary.eligibleForRMD
    : rmdData.customerEligible;
});
export const getIsRMDPreEligible = createSelector(getRMDData, (rmdData) => {
  return rmdGaugeEnabled()
    ? rmdData?.rmdSummary.preRMDEligible
    : rmdData.customerPreEligible;
});
